import React from 'react';
import { Link } from 'react-router-dom';
import { ARTIST_CARD } from '@/constants/testIds';
import { Star, MapPin, BadgeCheck, Sparkles } from 'lucide-react';

const verifiedColor = {
  basic: 'text-cyan-300',
  professional: 'text-fuchsia-300',
  elite: 'text-amber-300',
};

const ArtistCard = ({ artist, showMatch = false }) => {
  if (!artist) return null;
  return (
    <Link
      to={`/artists/${artist.artist_id}`}
      data-testid={ARTIST_CARD.root}
      className="group relative block aspect-[3/4] rounded-2xl overflow-hidden card-glow border border-white/10 bg-[#13182C]"
    >
      <img
        src={artist.profile_image || artist.cover_image}
        alt={artist.stage_name}
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1100ms] group-hover:scale-110"
        loading="lazy"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0B1020] via-[#0B1020]/30 to-transparent" />

      {/* Top badges */}
      <div className="absolute top-3 left-3 right-3 flex items-start justify-between">
        {artist.verified_level && (
          <span className={`glass text-xs px-2.5 py-1 rounded-full flex items-center gap-1 ${verifiedColor[artist.verified_level] || 'text-cyan-300'}`}>
            <BadgeCheck className="h-3.5 w-3.5" />
            <span className="capitalize">{artist.verified_level}</span>
          </span>
        )}
        {showMatch && artist.match_score && (
          <span className="glass px-2.5 py-1 rounded-full text-xs text-emerald-300 flex items-center gap-1">
            <Sparkles className="h-3.5 w-3.5" />
            {artist.match_score}% match
          </span>
        )}
      </div>

      {/* Bottom info */}
      <div className="absolute inset-x-0 bottom-0 p-5">
        <div className="flex flex-wrap gap-1 mb-2">
          {(artist.categories || []).slice(0, 2).map((c) => (
            <span key={c} className="glass px-2 py-0.5 rounded-full text-[10px] uppercase tracking-wider text-slate-200">
              {c}
            </span>
          ))}
        </div>
        <h3 className="font-display text-white text-xl font-semibold leading-snug">
          {artist.stage_name}
        </h3>
        <div className="flex items-center justify-between mt-2 text-xs text-slate-300">
          <span className="flex items-center gap-1">
            <MapPin className="h-3.5 w-3.5" /> {artist.location_city || '—'}
          </span>
          <span className="flex items-center gap-1 text-amber-300">
            <Star className="h-3.5 w-3.5 fill-amber-300" /> {Number(artist.rating_avg || 0).toFixed(1)}
          </span>
        </div>
        {(artist.price_min || artist.price_max) ? (
          <div className="mt-3 text-[11px] text-slate-400">
            Starts at <span className="text-white font-medium">₹{Number(artist.price_min || 0).toLocaleString('en-IN')}</span>
          </div>
        ) : null}
      </div>
    </Link>
  );
};

export default ArtistCard;
